/* eslint-disable */ 
export const menuList = [
    {
        key: 'home',
        name: '首页'
    },
    {
        key: 'solutions',
        name: '解决方案'
    },
    {
        key: 'partners',
        name: '合作伙伴'
    },
    {
        key: 'cases',
        name: '成功案例'
    },
    {
        key: 'about',
        name: '关于我们'
    }
];

export const homeData = {
    summary: [
        {number: '10000', desc: '客户数', icon: 'client-num', plus: true},
        // {number: '2000+', desc: '客户数', icon: 'client-num'},
        {number: '80万', desc: '创意素材', icon: 'account-num', plus: true},
        // {number: '3000+', desc: '服务账户数', icon: 'account-num'},
        {number: '千亿级', desc: '月曝光量', icon: 'impression-num'},
        {number: '100', desc: '专业服务团队', icon: 'team-num', plus: true}
    ],
    solutions: [
        {
            id: 1,
            title: '投前准备',
            brief: '一键轻松开通3大海外头部媒体账户。我们拥有跨媒体，跨产品类型的丰富投放经验与营销数据，为您生成定制化投放计划、本土化指导。',
            icon: 'prepare',
            anchor: 'prepare',
            content: [
                '一键轻松开通3大海外头部媒体账户。',
                '我们拥有跨媒体，跨产品类型的丰富投放经验与营销数据，为您生成定制化投放计划、本土化指导。',
                '专业课程&专员指导解答您从新手到进阶的所有疑问。'
            ]
        },
        {
            id: 2,
            title: '创意管理',
            brief: '素材库，积累海量创意作品，为您提供跨媒体、跨产品种类的优质素材。素材列表，轻松跨媒体管理您的素材以及素材表现，提供专业的素材优化建议。',
            icon: 'manage',
            anchor: 'manage',
            content: [
                '素材库，积累海量创意作品，为您提供跨媒体、跨产品种类的优质素材。',
                '素材列表，轻松跨媒体管理您的素材以及素材表现，提供专业的素材优化建议。',
                '素材剪裁工具，只需简单设置，系统自动为您生成不同媒体的适配素材。'
            ]
            // content: [
            //     '程序化创意，海量创意元素，基于算法进行内容优化，自动生成创意。',
            //     '动态创意工具，一次设置，即可为不同的广告受众个性化推荐符合需求的商品或服务。',
            //     '免费落地页制作工具，提供大量优质模板，可快速制作推广页面。'
            // ]
        },
        {
            id: 3,
            title: '一键投放',
            brief: '智能投放系统：投放API，一键跨媒体。百度全球领先的AI技术，系统监测账户投放情况，自动开启账户分析，提供优化策略。',
            icon: 'launch',
            anchor: 'quickLaunch',
            content: [
                // '智能投放系统：',
                '对接各媒体API，一键跨媒体开户，上传素材，创建广告计划等。',
                '百度全球领先的AI技术，系统监测账户投放情况，自动开启账户分析，提供优化策略。',
                '自动化报告与Report API，为您提供定制化、定时自动推送的跨媒体数据报告(即将推出该新功能)。'
            ]
            // content: [
            //     '智能投放系统：',
            //     '投放API，一键跨媒体开户，上传素材，创建广告计划等。',
            //     '百度全球领先的AI技术，结合海量的营销数据与丰富的投放经验，系统自动分析账户，提供优化策略。',
            //     '自动化报告与Report API，为您提供定制化的跨媒体数据报告。'
            // ]
        },
        {
            id: 4,
            title: '智能优化',
            brief: '系统自动进行广告设置的完整性监测。跨媒体创意分析，聚合媒体数据，自动生成创意效果报告与创意优化策略建议。',
            icon: 'optimize',
            anchor: 'optimize',
            content: [
                '系统自动进行广告设置的完整性监测，引导客户进行修改。',
                '跨媒体创意分析，聚合媒体数据，自动生成创意效果报告与创意优化策略建议。',
                '聚合多媒体投放数据，构建用户画像，针对不同投放目标提供受众优化建议。'
            ]
        },
        {
            id: 5,
            title: '专业服务',
            brief: '7个本土化团队，帮助您进行本土化广告投放。专业的优化师团队，提供全时区的一对一广告优化策略指导，让您轻松达成广告投放目标。',
            icon: 'serve',
            anchor: 'serve',
            content: [
                '7个本土化团队，帮助您进行本土化广告投放，有效提升投放效益。',
                '专业的优化师团队，提供全时区的一对一广告优化策略指导，让您轻松达成广告投放目标。',
                '庞大的设计师团队，激发创意灵感，汇聚精华，为您提供定制化的创意制作。'
            ]
        }
    ],
    cases: [
        {
            id: '0',
            icon: 'snapchat',
            title: 'Snapchat',
            detail: {
                name: '莉莉丝',
                logo: 'lilisi',
                desc: `莉莉丝，作为中国领先的游戏开发者和发行商，推出了多款备受赞赏的手机游戏，
                        为全世界超过1亿的玩家带来了欢乐。在推广他们新款休闲类RPG游戏AFK Arena时，
                        他们和Snapchat合作，在大范围获取新客的同时，也推动了用户对其游戏的认知。`,
                data: [
                    {title: '低于其他渠道的CPI', number: '20%'},
                    {title: '营销渠道', number: 'TOP.3'},
                    {title: '高于其他渠道的留存率', number: '8%'},
                    {title: '针对目标更高的LTV', number: '20%'}
                ],
                solution: [
                    {icon: 'flower', content: 'Snap Ads 和 Story Ads结合'},
                    {icon: 'flower', content: 'Lookalike和自定义受众'},
                    {icon: 'flower', content: '游戏场景和角色素材结合'}
                ],
                screenshot: 'lilisi',
                isVideo: true
            }
        },
        {
            id: '1',
            icon: 'pinterest',
            title: 'Pinterest',
            detail: {
                name: 'Lively',
                logo: 'lively',
                desc: `Lively是一个以舒适为卖点的内衣品牌，它推崇性感舒适剪裁的bralettes，因为它们时尚而动感。
                        创始人Michelle Cordeiro Grant 来自维多利亚的秘密，她想要创建一种思维方式，可以让女性随心生活，做想做的事。`,
                data: [
                    {title: 'ROAS比其它渠道高出', number: '90%'},
                    {title: '点击率是其他渠道', number: '2.6X'},
                    {title: '客单价比其他渠道高出', number: '9%'}
                ],
                solution: [
                    {icon: 'flower', content: 'Collections Format'},
                    {icon: 'flower', content: '高相关性落地页'},
                    {icon: 'flower', content: '不重叠的受众地位'}
                ],
                screenshot: 'lively-poster'
            }
        },
        {
            id: '2',
            icon: 'reddit',
            title: 'Reddit',
            detail: {
                name: 'Zynga',
                logo: 'zynga',
                desc: `Zynga Inc.是一家运行社交视频游戏服务的美国社交游戏开发商，成立于2007年4月，总部位于美国加利福尼亚州的旧金山。
                    该公司主要专注于移动和社交网络平台。Zynga的使命是“通过游戏连接世界”。希望通过Reddit可以投放到更多精准定位的市场。`,
                data: [
                    {title: 'LTV与美国其他新兴的社交渠道相比', number: '1.5X'},
                    {title: '比自然流量留存率高出', number: '16%'},
                    {title: 'CVR与Reddit的游戏大盘平均数据相比', number: '1.5X'}
                ],
                solution: [
                    {icon: 'flower', content: '利用视频实现在转化漏斗底部的成功'},
                    {icon: 'flower', content: '使定位市场与广告素材产生共鸣'},
                    {icon: 'flower', content: '在不同的兴趣受众群组中测试不同的广告格式'}
                ],
                screenshot: 'lively-poster',
                isVideo: false
            }
        }
    ],
    partner: [
        {name: 'snapchat', logo: 'snapchat', title: 'Snapchat'},
        // {name: 'asm', logo: 'asm', title: 'Search Ads'},
        {name: 'pinterest', logo: 'pinterest', title: 'Pinterest'},
        {name: 'reddit', logo: 'reddit', title: 'Reddit'}
    ],
    mobileCases: [
        {
            id: '0',
            icon: 'snapchat-head',
            title: 'Snapchat',
            detail: {
                name: '莉莉丝',
                logo: 'lilith-head',
                desc: `莉莉丝，作为中国领先的游戏开发者和发行商，推出了多款备受赞赏的手机游戏， 为全世界超过1亿的玩家带来了欢乐。在推广他们新款休闲类RPG游戏AFK Arena时， 他们和 Snapchat 合作，在大范围获取新客的同时，也加深了用户对其游戏的认知。`,
                data: [
                    {title: 'CPI 低于\n其他渠道', number: '20', unit: '%', compare: -1},
                    {title: '营销\n渠道', number: 'TOP3'},
                    {title: '高于其他渠道\n的留存率', number: '8', unit: '%', compare: 1}
                ],
                screenshot: 'lilisi',
                isVideo: true
            }
        },
        {
            id: '1',
            icon: 'pinterest-head',
            title: 'Pinterest',
            detail: {
                name: 'Lively',
                logo: 'lively-head',
                desc: `Lively 是一个以舒适为卖点的内衣品牌，它推崇性感舒适剪裁的 bralettes，因为它们时尚而动感。 创始人 Michelle Cordeiro Grant 来自维多利亚的秘密，她想要创建一种思维方式，可以让女性随心生活，做想做的事。`,
                data: [
                    {title: 'ROAS 比\n其它渠道高出', number: '90', unit: '%', compare: 1},
                    {title: '点击率是\n其他渠道', number: '2.6', unit: 'X', compare: 1},
                    {title: '客单价比\n其他渠道高出', number: '9', unit: '%', compare: 1}
                ],
                screenshot: 'lively'
            }
        },
        {
            id: '2',
            icon: 'tiktok-head',
            title: 'TikTok',
            detail: {
                name: 'TeraBox',
                logo: 'terabox-head',
                desc: `Terabox 是一款智能云存储软件，为所有注册用户提供1024GB的免费云存储空间，上线以来上榜多国工具类下载 top 榜单，DAU 和 MAU 体量快速增长。该产品通过 TikTok 平台将 KOL 产出的原生视频内容与广告推广结合，快速在重点国家获取新客的同时，培养了用户对云存储产品的使用习惯。`,
                data: [
                    {title: '次留\n提升', number: '20', unit: '%', compare: 1},
                    {title: '次留成本\n降低', number: '10', unit: '%', compare: -1},
                    {title: '正式推广后\nDAU 快速突破', number: '1', unit: 'M', compare: 1}
                ],
                screenshot: 'terabox',
                isVideo: true
            }
        },
        {
            id: '3',
            icon: 'taboola-head',
            title: 'Taboola',
            detail: {
                name: 'Roborock',
                logo: 'roborock-head',
                desc: `石头科技专注智能清洁机器人及其他智能电器研发和生产，致力于用创新简化生活。希望用科技帮助人们可以把更多的时间花在自己喜欢的事情上，而不是花在家务上。通过使用 Taboola 的视频广告并贯穿呈现在优质的内容网站，帮助他们重定向潜在受众，转化营销漏斗底层客户。`,
                data: [
                    {title: '累计获得\n曝光量', number: '1804', unit: '万', compare: 1},
                    {title: '广告完整\n播放量', number: '423', unit: '万', compare: 1},
                    {title: 'CPM\n降低', number: '25', unit: '%', compare: -1}
                ],
                screenshot: 'taboola-poster'
            }
        },
        {
            id: '4',
            icon: 'outbrain-head',
            title: 'Outbrain',
            detail: {
                name: 'Lilysilk',
                logo: 'lilysilk-head',
                desc: `从床上用品到睡衣和时装，生活时尚品牌 Lilysilk 为消费者提供一系列优质丝绸产品。多年来，Lilysilk 不断通过社交平台和搜索引擎等渠道推广其产品，已为其线上业务带来巨大营收。为了在除 Google、Facebook 等闭环生态外，以最佳的 CPA 触及高参与度受众，该品牌选择与 Outbrain 一起，在开放网络展开原生广告推广活动。`,
                data: [
                    {title: '平均页面停留时间\n较 Facebook 高出', number: '20', unit: '%', compare: 1},
                    {title: '跳出率较\nFacebook 低', number: '15', unit: '%', compare: -1},
                    {title: 'CPA 较\nFacebook 低', number: '25', unit: '%', compare: -1}
                ],
                screenshot: 'outbrain-poster'
            }
        },
        {
            id: '5',
            icon: 'reddit-head',
            title: 'Reddit',
            detail: {
                name: 'Zynga',
                logo: 'zynga-head',
                desc: `Zynga Inc. 是一家运行社交视频游戏服务的美国社交游戏开发商，成立于2007年4月，总部位于美国加利福尼亚州的旧金山。 该公司主要专注于移动和社交网络平台。Zynga 的使命是“通过游戏连接世界”。希望通过 Reddit 可以投放到更多精准定位的市场。`,
                data: [
                    {title: 'LTV 与美国其他新兴\n的社交渠道相比', number: '1.5', unit: 'X', compare: 1},
                    {title: '比自然流量\n留存率高出', number: '16', unit: '%', compare: 1},
                    {title: 'CVR 与 Reddit 的游戏\n大盘平均数据相比', number: '1.5', unit: 'X', compare: 1}
                ],
                screenshot: 'zynga'
            }
        }
    ]
};

export const caseDetailInfo = {
    caseList: [
        {
            id: 1,
            title: 'LIVELY',
            desc: 'Pinterest 助力LIVELY 重新定义性感，点亮女性多元美。',
            logo: 'lively',
            poster: 'lively',
            background: [`LIVELY 一直致力于展示多元化风格的女性内衣产品以此来获取更多市场，而这一理念得以在它的Pinterest集合广告中完美实现。`],
            data: [
                {number: '90%', tip: 'ROI和其他渠道比高出'},
                {number: '8%', tip: '点击率和其他渠道比'},
                {number: '20%', tip: '平均客单价和其他渠道比高出'}
            ],
            solution: [`Pinterest 的集合广告能够让广告主在一个广告中展现多个产品。对于LIVELY来说，集合广告可以同时展现形色各异的新款产品组合。
                在Pinterest集合中，LIVELY选择的主图除了包含主打产品外，还配有LOGO，标题文字，
                和清晰的用户行为号召。而配图则展示了与主打产品相关的单品模特图。`],
            strategy: [`相关性很重要。要确保每一个落地页与广告中所展示的内容相关，以此来实现最佳的客户体验。此外，
                还需注意集合广告中的主图应当于多个产品相关联。有的放矢地运用创意。在充分了解用户消费习惯的前提下，
                制订多种广告版本迎合用户个性化需求。如果有多个广告活动同时进行，要注意各个广告针对的市场不能重复，以免造成不良的内部竞争。`],
            comment: [`LIVELY丰富多样的产品线直接决定了我们选择Pinterest的集合广告模式，即每个广告里可以包含多个产品。
                这有助于我们向消费者展示多种颜色和款式的内衣，以此来轻松地进行组合搭售。`]
        },
        {
            id: 2,
            title: 'TED BAKER',
            desc: '英国设计师品牌Ted baker携手Pinterest为新人提供筹婚攻略，成功涉足婚纱礼服行业。',
            logo: 'tedBaker',
            poster: 'tedBaker',
            background: [`始于1980年的Ted baker从一开始专做男士服装的设计师品牌到现如今英国本土发展最迅速的时装品牌，
                一路走来不断尝试新的领域，开拓了包括女装，鞋包配饰等多种品类，而这一次Ted baker想要重塑自己在准新人们心中定位——不仅是一个高定礼服品牌,更是一个专业的婚礼服饰品牌。`],
            data: [
                {number: '800+', tip: '引流到官网婚纱专题页访客'},
                {number: '400+', tip: '引流到线下门店的预约咨询'}
            ],
            solution: [`Ted baker 的团队首先列出了整个客户体验流程，从一开始的获取信息到最终的达成购买，每一个环节的触达点都至关重要。
                当准新人们在Pinterest上搜索有关婚礼的关键词时，就能看到 Ted baker发布的例如婚礼策划小贴士等相关内容的或是婚礼服饰产品的推广图钉。
                Ted baker在Pinterest上还设立了“Wed with ted”（婚礼专栏)，以此来帮助人们解决婚礼主题，服饰搭配，新娘护肤等问题。此外，Ted baker还将Pinterest上最热门的婚礼服饰产品推广图钉成宣传材料，
                在线下门店发放。顾客扫码即可浏览Ted baker在Pinterest上发布过的所有婚礼相关内容，
                以此为Pinterest渠道和官网的婚纱礼服主题页获得更多的流量。`],
            strategy: [`婚礼相关话题是英国Pinterest渠道上的热搜之一，因此客户通过在婚礼旺季时期在pinterest上发布相关贴士，迅速拉近与客户的距离，
                提升自己在婚纱礼服领域的专业形象。利用Pinterest的推广图钉功能，在其发布的内容中内置预约线下门店婚礼咨询的链接，
                为客户打造一站式婚礼服务体验。`],
            comment: [`Pinterest 是一个极佳的推广平台，它可以帮助消费者去发现我们的产品，并让我们的品牌融入他们的生活，一起见证那些美好的时刻。
            这一次的推广活动是如此的成功，我们将继续采用Pinterest在全球范围内帮助Ted baker宣传造势。`]
        },
        {
            id: 3,
            title: 'REISS',
            desc: '通过Pinterest，塑造Reiss的全方位品牌形象，横扫欧洲男装市场。',
            logo: 'reiss',
            poster: 'reiss',
            background: [`Reiss此前也在Pinterest上发布特色专栏主题内容，且针对的目标客户大多是女性。但自从使用了Pinterest自带的成效分析功能后，
                不仅让发布的内容更有互动性，为品牌形象增添个性色彩，更成功开拓了男装市场。`],
            data: [
                {number: '22%', tip: '官网流量增长'},
                {number: '24%', tip: '官网销售额增长'}
            ],
            solution: [`从应季的服饰搭配推荐，到旅游和美食攻略，Reiss在Pinterest平台上向消费者们展示了自己全方位的品牌形象，
                宣扬轻奢、自由、享乐的生活态度，引起目标群体的身份认同，以此来激发更多的互动和转化。`],
            strategy: [`利用Pinterest自带的分析功能，追踪每一个推广图钉的数据表现，不断优化迭代发布的内容，以此来找到目标客户群体感兴趣的点。
                正因为如此，Reiss意外发现，男装封面的内容表现出色，从而与男装时尚博主合作，并将Pinterest推广内容插入EDM，大获成功。`],
            comment: [`在所有的社交媒体渠道中，Pinterest为我们带来订单的平均客单价是最高的。`]
        },
        {
            id: 4,
            title: 'NORDSTROM',
            desc: '通过以Pinterest为核心的客户体验，实现服饰品牌新零售。',
            logo: 'nordstrom',
            poster: 'nordstrom',
            background: [`作为最早一批使用Pinterest的企业用户之一，Nordstorm一开始就明确了自己在社交媒体平台上的角色，即帮助消费者找寻生活中的灵感。
                Nordstorm通过在Pinterest账号上发布官网上的热销产品，转发消费者喜欢的热门话题内容和时尚穿搭教程，收获了大批粉丝的追捧和关注。`],
            data: [
                {number: '450W+', tip: '新增粉丝'},
                {number: '100W+', tip: '月均流量引入官网'}
            ],
            solution: [`起初，Nordstorm仅仅是根据时装周的季节来分类Pinterest上的内容版块。自2013年起，Nordstorm将Pinterest账号完全打造
                成了以客户体验为核心的平台，让消费者自己票选出最喜爱的产品并按照分类设置专栏。`],
            strategy: [`自2013年起，Nordstorm推行了线上线下相结合的新零售模式。在线下门店里，将Pinterest平台上最热门的产品挂上
                Pinterest的logo作为标记，让顾客进店购买时一目了然找到心仪的单品，并通过店员手里的app关联仓储信息让顾客即时了解爆款库存。`],
            comment: [`我们最喜欢Pinterest的一点是在于，目标客户可以通过我们分享的内容受到启发和灵感，进而产生自发的收藏，评论，分享等行为。
                从某种意义上来说，Pinterest更像是一个覆盖全世界的超级心愿单。有了Pinterest的帮助，我们可以通过每日的数据表现，
                从粉丝的互动行为中得知哪些内容和产品是更受欢迎的。`]
        },
        {
            id: 5,
            title: 'HUNTER',
            desc: '打破Hunter原有的传统风格，借力Pinterest平台，掀起年轻时尚的雨具潮流。',
            logo: 'hunter',
            poster: 'hunter',
            background: [`英国百年本土雨靴品牌Hunter一直致力于为顾客提供最高质量的雨具产品，但是它的营销策略却始终摆脱不了陈旧感。
                因此，Hunter决定用一种全新的方式来触达更年轻的消费者群体。`,
            `在2016年，Hunter为它的核心金典雨靴发起了Pinterest短视频营销活动，告诉人们下雨天也可以充满乐趣和时尚感，提升品牌曝光度。`],
            data: [
                {number: '30%', tip: '品牌关键词搜索增长'},
                {number: '10%', tip: '用户口碑增长'}
            ],
            solution: [`Hunter利用短视频让顾客可以直观地浏览动态的产品信息，并在短视频内附上该产品的推广图钉，以此来引流到相应的产品落地页。`],
            strategy: [`Hunter推出了两个版本的视频广告：32秒钟版本涵盖整个经典系列产品；10秒钟版本则主打宣传了一件黄色雨衣。
            这两个视频当中附上的推广产品图钉和对应落地页面长期有效，可以在后期消费者自发的传播中持续获得流量。此外，在短视频推广活动期间，
                Hunter还趁着热度开展了形式多样的线下营销活动。例如在伦敦东京开展经典系列快闪店，和著名时尚博主合作等，进一步提高品牌知名度。`],
            comment: [`Pinterest对于Hunter来说是一个至关重要的推广平台。因为通过这个平台的数据，我们才能发现那些对Hunter有着强烈购买意愿的客户。`]
        },
        {
            id: 6,
            title: 'DSW',
            desc: 'Pinterest100助力DSW把握最前沿的市场风向，成功触达年轻一代的消费者心理。',
            logo: 'dsw',
            poster: 'dsw',
            background: [`DSW一直致力于帮助顾客以最优的价格买到最称心的鞋子。在美国，加拿大，中东开设550家门店提供上千种鞋类款式满足不同的客户需求，
                其中包括著名品牌如NIKE,UGG等。DSW想要触达更多的年轻人来塑造时尚的品牌形象，这有利于在未来进军潮流配饰市场。
                有了之前在Pinterest平台上成功的先例，DSW深知要让年轻一代买单，必须要先在社交媒体平台炒热度。
                于是，他们在2018年制定了以互动数和关注人数为目标的营销活动。`],
            data: [
                {number: '45%', tip: '粉丝互动率增加'},
                {number: '25%', tip: '点击率增加'}
            ],
            solution: [`据调查，91%的Pinterest用户认为平台所提供的潮流推荐榜单具有很高的参考价值，而DSW正是看中了这一点，
                利用Pin100榜单的影响力为自己的新品造势。此外，Pinterest榜单本身，也为DSW在决定未来的选品上提供了宝贵的市场洞见。`],
            strategy: [`通过对未来时尚趋势的精准把握，DSW将自己在新的营销活动中定位成鞋类和配饰类的时尚潮流风向标。
                在活动中主推的几款新品都完美体现了Pinterest100中涵盖的几大潮流趋势。同时，
                DSW还会在Pinterest平台上教授人们如何用他们的产品搭配各类服装，并贴上相应的潮流Pin100标签，进一步提高关注度。`],
            comment: [`现在许多消费者尤其是相对年轻的客户群体。通常会将上Pinterest搜索相关产品话题内容看成是整个购买决策中关键的一环，
                因此你可以从Pinterest平台上收获极有价值的市场信息。`]
        },
        {
            id: 7,
            title: 'ZAFUL',
            desc: 'ZAFUL巧用Snapchat的goal based bidding（目标竞价功能，简称GBB），进一步优化投放的受众群体，实现广告效益最大化。',
            logo: 'zaful',
            poster: 'zaful',
            background: [`ZAFUL是一家提供一站式女装产品的快时尚电商平台。ZAFUL想要利用APP安装广告来引导Snapchat上的女性用户来安装APP，
                浏览ZAFUL的移动端页面并最终达成购买。`],
            data: [
                {number: '50%', tip: '和其他渠道相比安装成本降低'},
                {number: '20%', tip: '和其他渠道相比达成购买成本降低'}
            ],
            solution: [`ZAFUL利用Snapchat的App安装广告来引导用户进行上滑操作并进入ZAFUL的APP安装详情页。`],
            strategy: [`为了能找到合适的投放目标客户，他们把投放范围扩大到美国，欧洲，中东的各年龄阶层的女性用户，并采用GBB的竞价模式，
                以此来优化投放广告的目标群体。通过尽可能地向转化率高的用户群体展示该App安装广告，将平均安装成本降到最低。此外，
                ZAFUL还测试了不同的广告投放素材组合来不断优化广告效果，增加效益。`],
            comment: [`我们认为Snapchat平台上的客户对于快时尚相关的内容很感兴趣，这恰好与我们的目标市场非常契合。`]
        },
        {
            id: 8,
            title: 'AFK Arena',
            desc: 'Snapchat 协力AFK Arena优化素材测试成本，使用本地化广告引领游戏新风口。',
            logo: 'afkArena',
            poster: 'afkArena',
            background: [`莉莉丝是知名的中国游戏公司，致力于成为游戏发行及研运一体的公司。19年重磅推出的产品AFK Arena是一款集RPG、卡牌和策略等元素于一体的、
            有深度故事内容的游戏。在此基础上，它又更着重于游戏世界画面的呈现，尝试以此提高用户的投入度和沉浸式游戏体验。`],
            data: [
                {number: '1.9亿', tip: '提供用户基数高达'},
                {number: '70%', tip: '提供IOS端用户占比高达'}
            ],
            solution: [`在分析阶段，对高质量付费用户进行深度挖掘，根据用户画像中包含的受众特点如年龄，性别，兴趣及其它基础特征，扩大受众投放范围，
            打捞出海量和产品定位匹配前期的用户。此外，为了扩大品牌影响力，保证用户的良好体验，AFK还花费一部分比例预算用于以Engagement为目标的投放，
            保证了用户能够与AFK在Snapchat上进行互动，以较低的成本营造出了游戏的沉浸式体验。在本次投放中，素材的本地化是十分重要的。
            根据当地市场热门的元素，测试出用户接受度最高的色系，主视觉，配乐风格及人物形象，再在此基础上做调整。另外素材的重复利用也有利于极大提高测试效率，以优质素材样式为模版，更换主要游戏场景，能够大幅度提高Campaign测试效率。`],
            strategy: [`本次Snapchat投放搭配使用Snap Ads和Story Ads. 首先我们利用Snap Ads进行高频次大批量的测试。在素材和受众的交叉测试中，
                AFK确认了目标受众接受的素材风格和可接受价格，在此基础上，将各项测试后的最终元素相结合，投放Story Ads，极大降低了Story Ads的测试成本。
                素材和产品相结合是非常重要的，在本次投放中，基于我们游戏精美的画面，多元的玩法和环节，拆分出不同的思路，在素材中分方向对游戏玩法和
                主要卖点相结合，进行分批次测试。通过制定全套素材方案，分层级分顺序测试了不同的游戏场景及游戏人，我们很快筛选出合适的素材方向，进行扩量投放。
                此外，我们非常重视素材中的音频和配乐，利用高亢激昂的人声去引导用户下载和体验游戏。`,
            `在受众选择上，我们先使用游戏相关标签，为AFK获取了早期精准用户。
                在此基础上,我们选择相似用户，用已下载用户及已付费用户为种子用户，大量扩展高质量人群，并最终实现了量级的提升。`],
            comment: [`Snapchat作为一个高质量付费用户来源渠道，我们可以透过前期的高频素材和用户交叉测试，精准锁定客户喜好和降低后续的测试成本。
                基于平台的互动性，用户有着更高的游戏忠诚度和沉浸式体验。相信AFK Arena受益于高频曝光率和不断的素材调整，定能打造成为一款风口游戏。`]
        },
        // {
        //     id: 9,
        //     title: 'Rise Of Kingdoms',
        //     desc: 'SnapChat助力ROK快速实现优质用户扩量，长远建立良好品牌形象。',
        //     logo: 'riseOfKingdoms',
        //     poster: 'riseOfKingdoms',
        //     background: [`《文明觉醒》风格相当具有观赏性，包含建城，农耕，养殖，狩猎，训练军队，PK对战等在内的游戏模式十分有趣，
        //         多元化的文化底蕴也为这个游戏全球性的推广奠定了基础。`,
        //     `在海外经过几个月的初期测试，《文明觉醒》于2018年9月20日在全球142个地区App Store正式上线，而后通过半个多月的用户积累与运营，
        //         截止10月15日，《文明觉醒》占据着全球53个地区的游戏免费榜TOP100，并且先后在28个地区进入过游戏畅销榜TOP10。`],
        //     data: [
        //         {number: '80%', tip: '高质量游戏用户群体占比'},
        //         {number: '24%', tip: 'Snapchat用户收入和其他渠道相比高出'}
        //     ],
        //     solution: [`在测试阶段，利用Snapchat上多样的广告目标及广告形式，我们在早期对游戏的核心用户进行了精准的投放，并逐步利用LAL进行扩量，
        //         最终以较低的成本获取了更多的高质量用户。在分析及扩量阶段，我们保持高频的素材更换频率，并最终依靠优化出的爆款素材，
        //         成功帮助ROK获得更多的优质用户，完成从0到1的完美起步，保证了CPI稳定及游戏的良好回收。`,
        //     `在投放趋于稳定的后期，我们投放了Lens品牌广告，
        //         以游戏中的人物角色为Lens创意，吸引用户参与扮演游戏角色，提升ROK的品牌知名度和好感度，完成了从1到100的量级指数级扩大。在本次Campaign推广中，
        //         我们对素材做了充分挖掘，Headline高度强调参与和互动感，邀请客户加入游戏。在素材上，基于游戏产品特点的多维延伸，
        //         保证视频在色彩和画面结构上重点突出。`],
        //     strategy: [`我们采用了2种广告格式，第一种是snap ads，采用这种广告形式快速测试出广告中表现良好的元素，如主画面，色系及CTA等，再在此基础上，
        //         将表现较好的Snap ads拼接为Story Ads，配上有吸引力的封面，单独投放Story Ads。`,
        //     `在素材上，我们遵循Snapchat素材制作的黄金法则- One message，
        //         根据游戏特点拆分出不同的场景，一次只表达一个人物或者一个游戏场景。这使得用户视觉重点集中，能快速获取产品信息。`,
        //     `在此基础上，
        //         我们充分体验游戏玩法，将精彩画面浓缩，提高信息的能量密度。在素材上给用户极大的视觉体验和震撼，配以激情动感的音乐，
        //         目标在最短的时间内快速吸引用户注意。`,
        //     `在前期投放中，使用第一批获取到的精准用户为种子用户，生成类似受众。后续投放中，
        //         我们会利用系统自动拓展出更多高倾向的下载及付费高质量用户，进行扩量投放。并且采取SnapChat的GBB（“goal-based bidding”）工具，
        //         凭借机器学习技术可以更高效定位高活跃度用户，增加广告互動率及浏览时长。`],
        //     comment: [`SnapChat用户与ROK玩家匹配度高，年龄层低的用户也能带来很高的转化率。稳定的转化率为我们带来了源源不断高支付质量的新用户，
        //         为未来盈利打下根基。ROK作为RPG游戏，会不断迭代推出更多新颖的游戏玩法，长期与SnapChat保持合作，让全球用户能够第一时间尝鲜，
        //         并建立长期品牌效应。`]
        // },
        {
            id: 10,
            title: 'SHEIN',
            desc: 'SHEIN携手Snapchat瞄准千禧一代，打通更低成本的获客路径。',
            logo: 'shein',
            poster: 'shein',
            background: [`SHEIN是一家覆盖全球224个国家的快时尚跨境电商品牌，拥有着超过一亿的用户。SHEIN下一步的计划着眼于一个全新的目标客户群体
                ----千禧一代。通过与Snapchat的深度合作，专门为年轻的消费者们打造了沉浸式体验的全屏手机广告。`],
            data: [
                {number: '20%', tip: '和其他渠道相比安装成本降低'},
                {number: '50%', tip: '和其他渠道相比达成购买成本降低'}
            ],
            solution: [`SHEIN利用Snapchat自带的优化工具，例如观众洞察功能（audience insight），和根据不同目标竞价的模式（GBB），让SHEIN更有机会接触到容易被转化的客户群体`],
            strategy: [`SHEIN采用了最佳的短视频广告形式来展示产品特写从正前方切换至俯拍的镜头，用来诱导观看者进行向上滑动的操作。同时，
                SHEIN还利用了Snapchat的生活方式相关话题来触达更多对时尚感兴趣的Snapchat用户。`,
            `除此之外，SHEIN还利用Store Ads向潜在客户展现了旗下产品线的深度和广度。投放素材经过测试优化后得出最佳的图片和文字组合，
                足以激发观看者的好奇心并诱导他们点击观看完整的故事广告。`],
            comment: [`Snapchat 一直帮助我们品牌建立与千禧一代沟通的桥梁。我们发现，在Snapchat的平台上，这些更有活力，更有创意的年轻客户群体也更容易被转化。`]
        },
        {
            id: 11,
            title: 'Zynga',
            desc: 'Reddit利用渠道的优势，助力Zynga精准定位，获取高质量的游戏用户。',
            logo: 'zynga',
            poster: 'zynga',
            // hasMulti: true,
            background: [`Zynga Inc.是一家运行社交视频游戏服务的美国社交游戏开发商，成立于2007年4月，总部位于美国加利福尼亚州的旧金山。
                该公司主要专注于移动和社交网络平台。Zynga的使命是“通过游戏连接世界”。希望通过Reddit可以投放到更多精准定位的市场。`],
            data: [
                {number: '1.5x', tip: '更高的客户终生价值（LTV），与美国其他新兴的社交渠道相比'},
                {number: '16%', tip: '更高的顾客留存率，与原有数值相比'},
                {number: '1.5x', tip: '更高的转换率（CVR），与Reddit的游戏基准相比'}
            ],
            solution: [`通过我们以客户目标为导向的业务团队，Zynga得以制定成功的目标定位策略。使得推广范围不仅覆盖游戏玩家，还覆盖了赛车爱好者。
                通过测试不同的受众群体定位和广告格式，有助于实现更高的客户生命周期价值`],
            strategy: [`利用视频实现在转化漏斗底部的成功`,
            `使定位市场与广告素材产生共鸣`, `在不同的兴趣受众群组中测试不同的广告格式`],
            comment: [`对于CSR2，与其他新兴社交渠道相比，Reddit成功地推动了LTV的1.5倍增长。 此外，留存率比任何来自其他渠道和自然搜索的安装都要好16％。 
                我们将继续在Reddit平台上寻找新的机会，以触达到更多更高质量的玩家。  —— Hagop Hagopian，Zynga增长营销高级经理`]
        },
        {
            id: 12,
            title: 'Adobe',
            desc: 'Reddit携手Adobe，刮起互联网艺术家们的Rlayer创作热潮',
            logo: 'adobe',
            poster: 'adobe',
            hasMulti: true,
            background: [`知名跨国公司，主要研发和销售多媒体软件。目标受众大多为艺术，设计，摄影专业的大学生群体。
                Reddit上数量众多的GenZ用户以及极其细分的兴趣社群是客户选择合作的根本原因。
                因为Adobe进入Reddit平台的目的是提高其云端素材库学生版的知名度并推动其转化，从而吸引独特的受众。 
                通过与Reddit合作，Adobe创造了同行中的第一个互联网热搜活动，随后跟进发布了效果广告。`],
            data: [
                {number: '#1', tip: '该社群在Reddit快速成长的社群排行榜中排名'},
                {number: '150k', tip: '图层在Adobe的素材云端被创建'},
                {number: '2.2x', tip: '提高品牌意识（与Kantar的同类目下的大盘基准相比）'},
                {number: '50%', tip: '和其他Adobe合作的媒体渠道比，ROI高出'},
                {number: '66%', tip: 'Adobe云端素材库的页面浏览量增加了'},
                {number: '5.7x', tip: '提高付费订阅意愿（与Kantar的同类目下的大盘基准相比）'}
            ],
            tips: 'Kantar Group是世界上最大最权威的广告数据监测以及咨询公司之一，竞争对手包括尼尔森和益普索。',
            solution: [`通过为Redditors提供独特的创作空间，Layer在各个创意社区中为Adobe建立了良好的品牌信誉。在这种品牌意识被激活之后，
            Adobe推出了针对艺术和以学生为中心的话题社区的定制广告素材，以推动转化。Adobe营销团队邀请了photoshopbattles社区的创始人Hero0fWar，
            仅使用Creative Cloud和Adobe Stock制作了视频广告，并投放在社区，引发热点。`],
            strategy: [`受Photoshop画布功能的启发，Reddit携手Adobe打造了可以让社群成员协同创作的画布，让全球Redditor可以在此画布上创作，
            不断产出艺术品。`,
            `在五天的时间里，成千上万的Redditor蜂拥而至。 在Layer社区上的共享画布上绘制超过150,000个“图层”。
            参与者有时甚至不定期地探索各种主题，从表情包到图标，从肖像到风景。 这项活动启发Redditors创建新的细分社区，
            例如延时视频，甚至是互动3D模型的图层艺术等。`],
            comment: [`我们在推广时更贴近Reddit创作者的利益和需求，而不是简单地投放广告。让Reddit的创意社区来指引我们营销的方向并建立我们的存在感，
            从而进一步增强品牌亲和力并得以推动销售。因此，我们将会与Reddit确立为长期媒体合作伙伴。`]
        },
        {
            id: 13,
            title: 'Xfinity',
            desc: 'Reddit帮助Xfinity在学生入驻校园的高峰季节快速获客，抢占先机',
            logo: 'xfinity',
            poster: 'xfinity',
            hasMulti: true,
            background: [`Xfinity是Comcast Corporation的子公司Comcast Cable Communications的品牌名，用于推销公司提供的消费者有线电视，互联网，
            电话和无线服务。该品牌于2010年首次推出；在此之前，这些服务主要以Comcast名称进行营销。Xfinity对Reddit上四分之一的Gen Z受众进行精准投放。`],
            data: [
                {number: '68%', tip: '更高的VCR（与Reddit的大盘基准相比）'},
                {number: '3.7x', tip: '更高的无品牌意识（与Kantar的大盘基准相比）'}
                // {number: 'xx%', tip: '较高的广告重播率（与Kantar的大盘基准相比）'}
            ],
            tips: 'Kantar Group是世界上最大最权威的广告数据监测以及咨询公司之一，竞争对手包括尼尔森和益普索。',
            solution: [`因为四分之一的Redditor是Z世代，Xfinity选择了Reddit，在兴趣社群里与他们产品最相关的受众（大学生）进行互动。
                Xfinity使用现有的简短社交视频和静态广告素材，在学生入驻校园的高峰季节在Reddit上发布广告，快速提高受众对独家优惠的认识。 
                Xfinity凭借真实原创的素材，在游戏，运动，幽默和大学生等分类社群中吸引了Gen Z。`],
            strategy: [`利用Reddit术语（“ TIL”等）与Redditor进行真实自然的对话`,
            `使用不同的广告格式（推广视频，静态图）并轮播广告素材以避免疲劳`],
            comment: [`“与Reddit的品牌战略团队达成合作，创造了许多可以引起Gen Z 产生共鸣的社交素材。 由于这次合作的出色成绩和整体成功的经验，
                我们对在Reddit上推广的下一次Campaign感到非常期待。”  —— Comcast社群营销执行总监Nader Ali-Hassan`]
        },
        {
            id: 14,
            title: 'THREAD',
            desc: 'Reddit助力Thread 以低成本获取高质量，高终身价值的客户',
            logo: 'thread',
            poster: 'thread',
            // hasMulti: true,
            background: [`Thread是一个在线的个人造型平台，旨在帮助男士找到心仪的衣服。 该平台提供了真人造型师和人工智能造型推荐的组合服务。
                顾客可以从真人造型师那里接收个性化推荐信息，同时也可以通过基于顾客偏好的机器算法中获得穿搭灵感，从而帮助男士轻松穿出时尚感而省去购物的麻烦。
                Thread的主要目标市场是对时尚有追求的男士，因此是一个Reddit更容易帮助其获客的细分领域。`],
            data: [
                {number: '86%', tip: '更有效的千次展示费用（对比其他主流媒体渠道）'},
                {number: '46%', tip: '降低每次注册费用（对比其他主流媒体渠道）'}
                // {number: 'xx%', tip: 'LTV / CPR增加（按照第一季度比率，对比第四季度比率）'}
            ],
            solution: [`通过测试各种细分受众群（地区，规模，设备），Thread运用了不同的出价策略来优化效果，同时持续更替新鲜的广告素材。
                他们首先在英国的Reddit进行投放，之后将成功的经验复制到美国市场的推广中。 他们创新的测试方法实现了高效的CPM，从而降低了单次注册费用（CPR）。`],
            strategy: [`为每个细分市场制定独特的出价策略`,
            `考虑首先进入非主要市场`, `持续上新广告，以防止广告疲劳`],
            comment: [`“在Reddit渠道上，我们看到了降低的单次注册成本（CPR），和增加的平均订单价值（AOV），这表明Reddit以低成本提供高质量的客户。”
                ——Thread的市场经理Nina Ricafort`]
        }
    ]
};

export const footerSeries = {
    '媒体介绍': [
        {
            id: 1,
            title: 'Snapchat',
            key: 'snapchat',
            keyName: 'id',
            path: 'partner-detail'
        },
        {
            id: 2,
            title: 'Pinterest',
            key: 'pinterest',
            keyName: 'id',
            path: 'partner-detail'
        },
        {
            id: 3,
            title: 'TikTok',
            key: 'tiktok',
            keyName: 'id',
            path: 'partner-detail'
        },
        {
            id: 4,
            title: 'Taboola',
            key: 'taboola',
            keyName: 'id',
            path: 'partner-detail'
        },
        // {
        //     id: 3,
        //     title: 'Apple Search Ads',
        //     keyName: 'id',
        //     path: 'partner-detail'
        // },
        {
            id: 5,
            title: 'Reddit',
            key: 'reddit',
            keyName: 'id',
            path: 'partner-detail'
        },
        {
            id: 6,
            title: 'Outbrain',
            key: 'outbrain',
            keyName: 'id',
            path: 'partner-detail'
        }
    ],
    '解决方案': [
        {
            id: 201,
            title: '投前准备',
            path: 'solutions',
            anchor: 'prepare'
        },
        {
            id: 202,
            title: '创意管理',
            path: 'solutions',
            anchor: 'manage'
        },
        {
            id: 203,
            title: '一键投放',
            path: 'solutions',
            anchor: 'quickLaunch'
        },
        {
            id: 204,
            title: '智能优化',
            path: 'solutions',
            anchor: 'optimize'
        },
        {
            id: 205,
            title: '专业服务',
            path: 'solutions',
            anchor: 'serve'
        }
    ],
    '合作伙伴': [
        {
            id: 301,
            title: 'Appsflyer',
            path: 'partners',
            anchor: 'partners'
        },
        {
            id: 302,
            title: 'Adjust',
            path: 'partners',
            anchor: 'partners'
        },
        {
            id: 303,
            title: 'Branch',
            path: 'partners',
            anchor: 'partners'
        },
        {
            id: 304,
            title: 'Shopify',
            path: 'partners',
            anchor: 'partners'
        },
        {
            id: 305,
            title: '店匠',
            path: 'partners',
            anchor: 'partners'
        },
        {
            id: 306,
            title: '广告中国',
            path: 'https://www.advertcn.com',
            anchor: 'mediago'
        }
    ],
    '关于我们': [
        {
            id: 401,
            title: '公司介绍',
            path: 'about'
        },
        {
            id: 402,
            title: '成功案例',
            path: 'cases'
        },
        {
            id: 403,
            title: '联系我们',
            path: 'home',
            anchor: 'contactUs'
        }
    ]
};

export const solutionPage = {
    mainText: [
        {
            id: 1,
            title: '客户自助发布',
            desc: `从起步到进阶，提供全方面的技术支持，<br />助您轻松达成投放目标`,
            list: [
                {
                    id: 11,
                    // img: require('../../../assets/images/home/solutions/text-11.png'),
                    icon: 'efficiency',
                    title: '提高您的工作效率',
                    desc: '一键开户、一键创建广告计划、跨媒体整合报告、自动化日报'
                },
                {
                    id: 12,
                    // img: require('../../../assets/images/home/solutions/text-12.png'),
                    icon: 'strategy',
                    title: '优化调整您的投放策略',
                    desc: '跨媒体，跨产品类型、丰富的投放经验、海量多维度的投放数据、专业的优化师团队、领先的AI技术自动化策略分析'
                },
                {
                    id: 13,
                    // img: require('../../../assets/images/home/solutions/text-13.png'),
                    icon: 'income',
                    title: '提高您的广告投放效益',
                    desc: '实时统计广告投放ROI、利用转化漏斗进行数据分析、关注每一个转化转变、多维度优化您的广告'
                },
                {
                    id: 14,
                    // img: require('../../../assets/images/home/solutions/text-24.png'),
                    icon: 'target',
                    title: '保证您的广告投放目标',
                    desc: 'AI技术结合人工智慧、专注您的每一个投放目标、系统自动进行相关数据指标预警'
                }
            ]
        },
        {
            id: 2,
            title: '百度代您投放',
            desc: '我们有技术，数据与专业团队，100％完成您的投放目标',
            list: [
                {
                    id: 21,
                    // img: require('../../../assets/images/home/solutions/text-21.png'),
                    icon: 'tech',
                    title: '百度领先的AI技术',
                    desc: '利用高级算法进行机器学习、自动化创意表现分析与优化建议、自动化注释用户画像、精准定位受众、定制化日报自动推送'
                },
                {
                    id: 22,
                    // img: require('../../../assets/images/home/solutions/text-22.png'),
                    icon: 'experice',
                    title: '海量的广告投放数据',
                    desc: '千亿级投放数据、跨媒体聚合、细分产品类型数据分析、提供全面的营销整合方案、提供有效的广告优化策略'
                },
                {
                    id: 23,
                    // img: require('../../../assets/images/home/solutions/text-23.png'),
                    icon: 'professional',
                    title: '专业的优化师团队',
                    desc: '细分媒体与产品类型、在擅长领域不断沉淀优化经验、24小时管理您的账户、为您的KPI负责'
                },
                {
                    id: 24,
                    // img: require('../../../assets/images/home/solutions/text-24.png'),
                    icon: 'guaranteed',
                    title: '保证您的广告投放目标',
                    desc: 'AI技术结合人工智慧、专注您的每一个投放目标、系统自动进行相关数据指标预警'
                }
            ]
        }
    ],
    processList: [
        {
            id: 'a1',
            // img: require('../../../assets/images/home/solutions/process1.png'),
            title: '投前准备',
            anchor: 'prepare',
            img: 'prepare',
            details: [
                {
                    text: '轻松开户',
                    desc: '一键开通3大海外头部媒体账户，开启您的海外营销之旅'
                },
                {
                    text: '定制化投放计划',
                    desc: '我们拥有跨媒体，跨产品类型的丰富发布经验与营销数据，为您生成定制化的跨媒体发布计划'
                },
                {
                    text: '本土化指导',
                    desc: '本土化是提高广告投放效益的关键，MediaGo遍布全球的本土化团队为您解决语言与文化障碍'
                },
                {
                    text: '帮助中心',
                    desc: '专业课程和专员指导解答您从起步到进阶的所有疑问'
                }
            ]
        },
        {
            id: 'a2',
            // img: require('../../../assets/images/home/solutions/process2.png'),
            title: '创意管理',
            anchor: 'manage',
            img: 'manage',
            details: [
                {
                    text: '素材库',
                    desc: '积累海量创意作品，为您提供跨媒体、跨产品种类的优质素材'
                },
                {
                    text: '素材列表',
                    desc: '轻松跨媒体管理您的素材以及素材表现，提供专业的素材优化建议'
                },
                {
                    text: '素材剪裁工具',
                    desc: '只需简单设置，系统自动为您生成不同媒体的适配素材'
                }
            ]
        },
        {
            id: 'a3',
            // img: require('../../../assets/images/home/solutions/process3.png'),
            title: '一键投放',
            anchor: 'quickLaunch',
            img: 'launch',
            details: [
                {
                    text: '智能投放系统',
                    isArray: true,
                    desc: [
                        '为您解决投放过程中的所有问题，提升投放效益',
                        '对接各媒体API，一键跨媒体开户、上传素材、创建广告计划等',
                        '百度全球领先的AI技术，结合海量的营销数据与丰富的投放经验',
                        '系统监测账户投放情况，自动开启账户分析，提供优化策略',
                        '多维度的跨媒体聚合数据报表，可视化数据分析展示',
                        '自动化报告与Report API，为您提供定制化、定时自动推送的跨媒体数据报告(即将推出该新功能)'
                    ]
                    // desc: '为您解决投放过程中的所有问题，提升投放效益',
                    // desc1: '对接各媒体API，一键跨媒体开户、上传素材、创建广告计划等',
                    // desc2: '百度全球领先的AI技术，结合海量的营销数据与丰富的投放经验',
                    // desc3: '系统监测账户投放情况，自动开启账户分析，提供优化策略',
                    // desc4: '多维度的跨媒聚合数据报表，可视化数据分析展示',
                    // desc5: '自动化报告与Report API，为您提供定制化、定时自动推送的跨媒体数据报告(即将推出该新功能)'
                }
            ]
        },
        {
            id: 'a4',
            // img: require('../../../assets/images/home/solutions/process4.png'),
            title: '智能优化',
            anchor: 'optimize',
            img: 'optimize',
            details: [
                {
                    text: '广告设置完整性监测',
                    desc: '系统自动进行广告设置的完整性监测，引导客户进行修改'
                },
                {
                    text: '创意优化策略',
                    desc: '跨媒体创意分析，聚合媒体数据，自动生成创意效果报告与创意优化策略建议'
                },
                {
                    text: '受众优化策略',
                    desc: '聚合多媒体投放数据，打造用户画像，针对不同投放目标提供受众优化建议'
                },
                {
                    text: '制定和预算调整策略',
                    desc: '系统自动进行帐户分析，监测出价与预算设置合理性，及时提出调整优化建议，帮助您触达更多目标用户'
                }
            ]
        },
        {
            id: 'a5',
            // img: require('../../../assets/images/home/solutions/process5.png'),
            title: '专业服务',
            anchor: 'serve',
            img: 'serve',
            details: [
                {
                    text: '本土化服务',
                    desc: '遍布全球的本土化团队，帮助您进行广告的本土化投放，有效提升投放效果'
                },
                {
                    text: '一对一的营销指导',
                    desc: '专业的优化师团队，提供全时区的广告优化策略指导，让您轻松达成广告投放目标'
                },
                {
                    text: '定制化创意制作',
                    desc: '庞大的设计师团队，激发创意灵感，汇聚精华，为您提供定制化的创意制作'
                }
            ]
        }
    ]
}

export const partnerPage = {
    mediaListData: [
        {
            icon: 'snapchat',
            id: 'snapchat',
            name: 'Snapchat',
            children: [
                {
                    key: 'snapchat',
                    title: '灵感神器Snapchat的营销法则'
                },
                {
                    key: 'snapchat-profile',
                    title: 'Snapchat预估覆盖用户'
                }
            ],
            disable: false,
            img: require('../assets/images/partners/snapchat-icon-detail.png'),
            details: 'Snapchat 是风靡全球的社交软件，是 AR 广告的开拓者和代入式品牌广告的倡导者，全球拥有超过5亿月活用户，可触达90% Z世代用户。',
            detailInfo: {
                imgList: [
                    require('../assets/images/partners/snapchat/sn-1.png'),
                    {
                        type: 'sn1',
                        bg: require('../assets/images/partners/snapchat/sn-2.png'),
                        list: [
                            {
                                img: require('../assets/images/partners/snapchat/sn-640.gif'),
                                title: '发现身边的朋友',
                                num: '3亿',
                                text: `Snapchatter 每月<br>都会打开地图探店`
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-641.gif'),
                                title: '阅后即焚大胆聊',
                                num: '81%',
                                text: `在 Snapchat 了解并特地购买了某些产品`
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-642.gif'),
                                title: '展现自我拥抱世界',
                                num: '2.3X',
                                text: `相较于非 Snapchatter，Snapchatter 使用特效镜`
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-643.gif'),
                                title: '观看精彩内容',
                                num: '56%',
                                text: `消费者经常在 Snapchat 上<br>探索激动人心的新品牌`
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-644.gif'),
                                title: '聚焦闪光瞬间',
                                num: '42%',
                                text: `消费者先在 Snapchat 上寻找购物/娱乐灵感`
                            }
                        ]
                    },
                    {
                        type: 'bg1',
                        bg: require('../assets/images/partners/snapchat/sn-3.png'),
                        list: [
                            require('../assets/images/partners/snapchat/sn-3-3.png'),
                        ]
                    },
                    {
                        type: 'sn2',
                        bg: require('../assets/images/partners/snapchat/sn-4.png'),
                        list: [
                            {
                                img: require('../assets/images/partners/snapchat/sn-51.gif'),
                                title: `Single Image or Video Ads: 
                                单个图片或视频广告`
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-52.gif'),
                                title: `Story Ads:
                                故事广告`
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-53.gif'),
                                title: `Collection Ads:
                                橱窗广告`
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-54.gif'),
                                title: `AR Lenses:
                                AR广告`
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-55.jpeg'),
                                title: `Filter:
                                贴纸广告`
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-56.gif'),
                                title: `Commercials:
                                商业广告`
                            }

                        ]
                    },
                    require('../assets/images/partners/snapchat/sn-5.png'),
                    {
                        type: 'bg2',
                        bg: require('../assets/images/partners/snapchat/sn-6.png'),
                        list: [
                            {
                                img: require('../assets/images/partners/snapchat/sn-6-1.png')
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-6-2.png')
                            },
                            {
                                img: require('../assets/images/partners/snapchat/sn-6-3.png')
                            }
                        ]
                    }
                ]
            }
        },
        {
            icon: 'pinterest',
            id: 'pinterest',
            name: 'Pinterest',
            children: [
                {
                    key: 'pinterest',
                    title: '灵感神器Pinterest的营销法则'
                },
                {
                    key: 'pinterest-profile',
                    title: 'Pinterest预估覆盖用户'
                }
            ],
            disable: false,
            img: require('../assets/images/partners/pinterest-icon-detail.png'),
            details: 'Pinterest 是可以帮助你找到并做你所爱事物的视觉发现引擎，有98%的用户表示自己会尝试在Pinterest 发现的新事物。',
            detailInfo: {
                title: '灵感神器Pinterest的营销法则',
                tips: '98% 的 Pinterest用户会尝试在 Pinterest 发现新的事物，84%的周活用户曾因为Pinterest上看到的品牌内容而进行消费。全球创意目录Pinterest让营销自然原生',
                imgList: [
                    require('../assets/images/partners/pinterest/1.jpeg'),
                    require('../assets/images/partners/pinterest/2.jpeg'),
                    require('../assets/images/partners/pinterest/3.jpeg'),
                    // require('../assets/images/partners/pinterest/4.jpeg'),
                    require('../assets/images/partners/pinterest/5.jpeg'),
                    require('../assets/images/partners/pinterest/6.jpeg'),
                    require('../assets/images/partners/pinterest/7.jpeg'),
                    require('../assets/images/partners/pinterest/8.jpeg'),
                    require('../assets/images/partners/pinterest/9.jpeg')
                ]
            }
        },
        {
            icon: 'tiktok',
            id: 'tiktok',
            name: 'TikTok',
            children: [
                {
                    key: 'tiktok',
                    title: 'TikTok'
                }
            ],
            disable: false,
            img: require('../assets/images/partners/tiktok-icon-detail.png'),
            details: 'TikTok是全球领先的移动短视频平台。全球月活突破10亿，覆盖150个国家和地区，包含35种语言，核心地区主要分布在北美、南美、欧洲、东南亚等。',
            detailInfo: {
                imgList: [
                    require('../assets/images/partners/tiktok/tt-1.png'),
                    {
                        type: 'bg3',
                        bg: require('../assets/images/partners/tiktok/tt-2.png'),
                        list: [
                            require('../assets/images/partners/tiktok/tt-02.png')
                        ]
                    },
                    require('../assets/images/partners/tiktok/tt-3.png'),
                    require('../assets/images/partners/tiktok/tt-4.png'),
                    require('../assets/images/partners/tiktok/tt-5.png')
                ]
            }
        },
        {
            icon: 'taboola',
            id: 'taboola',
            name: 'Taboola',
            children: [
                {
                    key: 'taboola',
                    title: 'Taboola'
                }
            ],
            disable: false,
            img: require('../assets/images/partners/taboola-icon-detail.png'),
            details: 'Taboola 为全球领先的内容推荐平台，以AI 技术精准提供人们感兴趣的资讯，拥有超过5亿日活用户，提供内容推荐、原生广告、跨境电商、全营销漏斗解决方案，尤其在效果营销上有卓越表现。',
            detailInfo: {
                imgList: [
                    require('../assets/images/partners/taboola/ta-1.png'),
                    require('../assets/images/partners/taboola/ta-2.png'),
                    require('../assets/images/partners/taboola/ta-3.png'),
                    {
                        type: 'bg4',
                        bg: require('../assets/images/partners/taboola/ta-4.png'),
                        list: [
                            require('../assets/images/partners/taboola/ta-04.png')
                        ]
                    },
                    require('../assets/images/partners/taboola/ta-5.png')
                ]
            }
        },
        {
            icon: 'reddit',
            id: 'reddit',
            name: 'Reddit',
            children: [
                {
                    key: 'reddit',
                    title: '灵感神器Reddit的营销法则'
                },
                {
                    key: 'reddit-profile',
                    title: 'Reddit预估覆盖用户'
                }
            ],
            disable: false,
            img: require('../assets/images/partners/reddit-icon-detail.png'),
            details: 'Reddit 拥有5亿广告可触达用户，是一股迅速崛起的营销新力量。Reddit 由超过10万个兴趣社区（被称为“Subreddits”）组成。',
            detailInfo: {
                title: '灵感神器Reddit的营销法则',
                tips: 'Reddit 是由超过13万个兴趣社群组成的社交平台，是互联网最有趣的地方和有高度组织的链接集中处，拥有超过200个游戏类兴趣小组中的重要社群，是游戏玩家花时间最多的地方之一...',
                imgList: [
                    require('../assets/images/partners/reddit/1.png'),
                    require('../assets/images/partners/reddit/2.png'),
                    require('../assets/images/partners/reddit/3.png'),
                    // require('../assets/images/partners/reddit/4.png'),
                    require('../assets/images/partners/reddit/5.png'),
                    require('../assets/images/partners/reddit/6.png'),
                    require('../assets/images/partners/reddit/7.png'),
                    require('../assets/images/partners/reddit/8.png'),
                    require('../assets/images/partners/reddit/9.png')
                ]
            }
        },
        {
            icon: 'outbrain',
            id: 'outbrain',
            name: 'Outbrain',
            children: [
                {
                    key: 'outbrain',
                    title: 'Outbrain'
                }
            ],
            disable: false,
            img: require('../assets/images/partners/outbrain-icon-detail.png'),
            details: 'Outbrain为每一位用户提供专属的推荐内容，可触达全球1/3的网民，拥有10亿用活跃用户，连接超过7000家媒体机构，平均月曝光量达到3440亿。',
            detailInfo: {
                imgList: [
                    require('../assets/images/partners/outbrain/out-1.png'),
                    {
                        type: 'bg4',
                        bg: require('../assets/images/partners/outbrain/out-2.png'),
                        list: [
                            require('../assets/images/partners/outbrain/out-02.png')
                        ]
                    },
                    require('../assets/images/partners/outbrain/out-3.png')
                ]
            }
        }
        // {
        //     icon: 'asa',
        //     id: 'asa',
        //     name: 'ASA',
        //     disable: true,
        //     details: 'Apple Search Ads 高效而便捷，可帮助用户在 App Store 搜索投放关键词时，在搜索结果的顶部快速发现您的 APP...'
        // }
    ],
    
    customerListData: [
        {
            logo: 'afkArena',
            title: 'AFK Arena',
            details: '莉莉丝是知名的中国游戏公司，着力于游戏发行及研运一体。19年拳头产品AFK Arena是一款集RPG、卡牌和策略等元素于一体的、有深度内容的放置类游戏。在此基础上，它又更着重于游戏世界观的呈现，尝试以此提高用户的投入度。',
            // img: require('../../../assets/images/home/partner/customer-1.png')
            img: 'afkArena'
        },
        // {
        //     logo: 'lively',
        //     title: 'LIVELY',
        //     details: 'LIVELY 一直致力于展示多元化风格的女性内衣产品以此来获取更多市场，而这一理念得以在它的Pinterest集合广告中完美实现。',
        //     img: require('../../../assets/images/home/partner/customer-2.png')
        // },
        // {
        //     logo: 'nordstrom-title',
        //     title: '',
        //     details: '作为最早一批使用Pinterest的企业用户之一，Nordstorm一开始就明确了自己在社交媒体平台上的角色，即帮助消费者找寻生活中的灵感。Nordstorm通过在Pinterest账号上发布官网上的热销产品，转发消费者喜欢的热门话题内容和时尚穿搭教程，收获了大批粉丝的追捧和关注。',
        //     img: require('../../../assets/images/home/partner/customer-3.png')
        // },
        {
            logo: 'shein',
            title: '',
            details: 'SHEIN是一家覆盖全球224个国家的快时尚跨境电商品牌，拥有着超过一亿的用户。SHEIN下一步的计划着眼于一个全新的目标客户群体----千禧一代。通过与Snapchat的深度合作，专门为年轻的消费者们打造了沉浸式体验的全屏手机广告。',
            // img: require('../../../assets/images/home/partner/customer-4.png')
            img: 'shein'
        }
    ],
    
    platformListData: [
        {
            icon: 'appsflyer',
            iconHover: 'appsflyer-hover'
        },
        {
            icon: 'adjust',
            iconHover: 'adjust-hover'
        },
        {
            icon: 'branch',
            iconHover: 'branch-hover'
        },
        {
            icon: 'shopify',
            iconHover: 'shopify-hover'
        },
        {
            icon: 'shoplazza',
            iconHover: 'shoplazza-hover'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/mobile/constants/home.js